export default [
  {
    path: '/banner',
    name: 'banner',
    component: () => import('@/views/menu/banner.vue'),
    meta: {
      pageTitle: 'مدیریت بنرها',
      action: 'show',
      resource: 'BannerManager',
    },
  },
  {
    path: '/banner/details/:id?',
    name: 'bannerdetails',
    component: () => import('@/views/menu/bannerdetails.vue'),
    meta: {
      pageTitle: 'جزئیات بنر',
      action: 'show',
      resource: 'BannerManager',
    },
  },
]
